import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import multiMonthPlugin from "@fullcalendar/multimonth";
import DrawerCalendarioTareasAudiovisualesMeets from "../../calendarioCitas/DrawerCalendarioTareasAudiovisualesMeets";
import Tippy from 'tippy.js';
import { toast } from "react-toastify";
import axios from "axios";
import { BACKEND } from "../../../config/configEnvs";
import { useState, useRef } from "react";

const CalendarioSeguimientoTareas = ({tasks}) => {

  const [openDrawer, setOpenDrawer] = useState(false)
  const [currentEvent, setCurrentEvent] = useState(null)
  const toastId = useRef(null)
  
  const firstTaskDeliverDate = tasks.filter((task) => task.deliverDate).length > 0
    ? tasks.filter((task) => task.deliverDate).sort((a, b) => new Date(a.deliverDate) - new Date(b.deliverDate))[0].deliverDate
    : null; 

  const selectEventInfoById = async (idEvent) => {
    try {
      toastId.current = toast.loading("Cargando evento...")

      const taskDetails = await axios.get(`${BACKEND}/api/tareasProyectos/${idEvent}?depth=5`);

      toast.done((toastId.current));
      setCurrentEvent(taskDetails.data);
      setOpenDrawer(true);

    } catch (error) {
      toast.done((toastId.current));
      toast.error("No existe este evento agendado")    
    }
  }

  return (
    <div className="flex-grow overflow-y-auto px-4">

      {/* Drawer de eventos */}
      <DrawerCalendarioTareasAudiovisualesMeets
        open={openDrawer}
        closeDrawer={()=>setOpenDrawer(false)}
        info={currentEvent}
      />

      <FullCalendar
        events={tasks
          .map((e) => ({
            title: `${e?.task.name 
                  + "  /  " + e.responsible?.name
                }`,
                start: e?.deliverDate,
                end: e?.deliverDate,
                color: e?.isVisit ? "#007BFF" : "#28A745",
                textColor: "white" ,
                className: "text-xs",
                id: e.id
              }))
            }
            initialDate={firstTaskDeliverDate}
            eventOrder={"order,start,-duration,title"}
            className="w-full h-[40vh] my-4"
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              listPlugin,
              multiMonthPlugin,
            ]}
            moreLinkText={"Ver todos"}
            locale={"es"}
            headerToolbar={{
              start: "title",
              center: "multiMonthYear,dayGridMonth",
              end: "prev,next",
            }}
            buttonText={{
              today: "Hoy",
              month: "Mes",
              year: "Año",
              week: "Semana",
              day: "Día",
              listMonth: "Agenda del mes",
              listDay: "Agenda hoy",
              timeGrid: "Semana",
            }}
            views={{
              timeGridFourDay: {
                type: "timeGrid",
                duration: { days: 4 },
                buttonText: "Semana",
              },
              timeGridWeek: {
                duration: { days: 7 },
                buttonText: "Semana",
              },
            }}
            initialView={"dayGridMonth"}
            moreLinkHint={true}
            defaultAllDay
            dayMaxEvents={false}
            eventContent={function (arg) {
              let containerEl = document.createElement("div");
              containerEl.classList = `event-container cursor-pointer hover:bg-[#FF9F57]`

              let contentEl = document.createElement("p");
              contentEl.classList = "event-content overflow-hidden";

              if (arg.event.extendedProps.isUrgent) {
                contentEl.innerHTML = "urgent event";
              } else {
                contentEl.innerHTML = `${arg.event.title}`;
              }

              containerEl.appendChild(contentEl);

              // Add click event listener
              containerEl.addEventListener("click", async function (event) {
                // Check if the clicked element matches the desired element
                if (event.target.classList.contains("event-content")) {
                  // Perform asynchronous logic
                  await navigator.clipboard.writeText(arg.event.id);

                  await selectEventInfoById(arg.event.id);
                }
              });

              return { domNodes: [containerEl] };
            }}
            eventDidMount={(info) => {
              Tippy(info.el, {
                content: info.event.title,
                placement: 'top',
                theme: 'dark',
                animation: 'scale'
              });
            }}
        initialEvents={[]}
      />
    </div>
  )
}

export default CalendarioSeguimientoTareas